import React from 'react';
import { Button, Card, Container, Grid, Typography } from '@mui/material';
import {
	PeopleAlt as PeopleAltIcon,
	SavedSearch as SavedSearchIcon,
} from '@mui/icons-material';
import { motion } from 'framer-motion';

const Features = () => {
	const colors = ['#0171d7', '#e91e63', '#4caf50', '#ff9800', '#9c27b0'];
	const titles = [
		'Analysis',
		'Design & Work Plan',
		'Development',
		'Testing & Deployment',
		'Maintenance',
	];
	const descriptions = [
		'We closely work with you to understand your business, products, target customers and competition. Accordingly, we develop a strategy suitable to your business goals.',
		'In this phase we develop the work plan and divide the same into multiple modules. Our UI/UX designers start designing the layouts.',
		'The core system is developed first and then additional functionalities are added to it. The ecommerce website makers then thoroughly optimize the site to ensure seamlessness.',
		'Before deploying the website to the live location, our testing team checks the functionality, security, compatibility, and usability of your site so that you are left with no complaint.',
		'Our eCommerce development services come with 90 days of free support. You may further upgrade it to an annual maintenance contract (AMC) at a reasonable price.',
	];

	const containerVariants = {
		hidden: {},
		visible: {
			transition: {
				staggerChildren: 0.3,
			},
		},
	};

	const itemVariants = {
		hidden: (direction) => ({
			opacity: 0,
			x: direction === 'left' ? -100 : 100,
		}),
		visible: {
			opacity: 1,
			x: 0,
			transition: {
				duration: 0.8,
			},
		},
	};

	return (
		<>
			<section className='section-5'>
				<Container>
					<Typography variant='h4'>
						Core Features of Our eCommerce Website Design Services
					</Typography>
					<p>Choose the best eCommerce development company in India.</p>
					<p>
						From custom layout design to required payment gateway integration,
						our eCommerce website developers treat every project in a unique
						manner. However, we follow a proven strategy to ensure a successful
						deployment within a quick turnaround time. Here it is:
					</p>
					<br />
					<br />
					<br />
					<motion.div
						variants={containerVariants}
						initial='hidden'
						animate='visible'>
						<Grid container spacing={4}>
							{[...Array(5)].map((_, index) => (
								<Grid
									item
									key={index}
									xs={12}
									sm={6}
									md={2.1}
									sx={{
										border: `1px solid ${colors[index]}`,
										paddingLeft: '10px',
										paddingTop: '64px',
										background: colors[index],
										textAlign: 'center',
										borderRadius: '50px',
										margin: { xs: '0', md: '0 10px' },
										marginTop: { xs: '20px', sm: '20px', md: '70px' },
										position: 'relative',
										'&::before': {
											content: '""',
											width: '100%',
											height: '100%',
											borderRadius: '50px',
											border: `1px solid ${colors[index]}`,
											position: 'absolute',
											left: '15px',
											top: '15px',
											zIndex: '-1',
										},
									}}>
									<motion.div
										variants={itemVariants}
										custom={index % 2 === 0 ? 'left' : 'right'}>
										<div className='styled-icon-wrapper'>
											<SavedSearchIcon className='saved-search-icon' />
										</div>
										<Typography variant='h6' sx={{ marginTop: '10px' }}>
											{titles[index]}
										</Typography>
										<p>{descriptions[index]}</p>
									</motion.div>
								</Grid>
							))}
						</Grid>
					</motion.div>
				</Container>
			</section>
		</>
	);
};

export default Features;
